import { SaveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { Field, reduxForm } from "redux-form"
import { changePassword } from "store/actions"
import validate from "./passwordValidation"

const ChangePasswordModal = ({
  closeHandler,
  handleSubmit,
  userId,
  changePassword,
  changePasswordInProgress,
  isOwnProfile,
}) => {
  const saveHandler = data => {
    changePassword({
      userId: userId,
      passwordsData: {
        old_password: data?.currentPwd,
        new_password: data?.newPwd,
        confirm_password: data?.newPwd2,
      },
    })
  }

  return (
    <form>
      {isOwnProfile && (
        <Row>
          <Col>
            <Field
              name="currentPwd"
              label="Current Password"
              component={TextField}
              type="password"
            />
          </Col>
        </Row>
      )}
      <Row className="my-2">
        <Col>
          <Field
            name="newPwd"
            label="New Password"
            component={TextField}
            type="password"
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="newPwd2"
            label="Repeat New Password"
            component={TextField}
            type="password"
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            content="Cancel"
            type="button"
            onClick={closeHandler}
            color="danger"
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            content="Save"
            type="button"
            onClick={handleSubmit(saveHandler)}
            loading={changePasswordInProgress}
          />
        </Col>
      </Row>
    </form>
  )
}

const mapStateToProps = state => ({
  changePasswordInProgress: state.Profile.changePasswordInProgress,
})

const mapDispatchToProps = dispatch => ({
  changePassword: values => dispatch(changePassword(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({ form: FORM_NAMES.CHANGE_PASSWORD, validate })(ChangePasswordModal)
)
